module.exports = __webpack_public_path__ + "img/m_bg_03.664bcd70.svg";